import React, { useCallback, useEffect, useState } from 'react';
interface PurchaseNotification {
  name: string;
  city: string;
  initials: string;
}
const NOTIFICATIONS: PurchaseNotification[] = [{
  name: 'María L.',
  city: 'Buenos Aires',
  initials: 'ML'
}, {
  name: 'Carlos T.',
  city: 'Córdoba',
  initials: 'CT'
}, {
  name: 'Lucía F.',
  city: 'Rosario',
  initials: 'LF'
}, {
  name: 'Juan P.',
  city: 'Mendoza',
  initials: 'JP'
}, {
  name: 'Ana M.',
  city: 'La Plata',
  initials: 'AM'
}, {
  name: 'Roberto S.',
  city: 'Tucumán',
  initials: 'RS'
}, {
  name: 'Florencia D.',
  city: 'Mar del Plata',
  initials: 'FD'
}, {
  name: 'Santiago R.',
  city: 'Salta',
  initials: 'SR'
}];
export function PurchasePopup() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [isExiting, setIsExiting] = useState(false);
  const showNotification = useCallback(() => {
    setIsExiting(false);
    setIsVisible(true);
    setTimeout(() => {
      setIsExiting(true);
      setTimeout(() => {
        setIsVisible(false);
        setIsExiting(false);
        setCurrentIndex(prev => (prev + 1) % NOTIFICATIONS.length);
      }, 500);
    }, 4000);
  }, []);
  useEffect(() => {
    const initialDelay = setTimeout(() => {
      showNotification();
    }, 5000);
    return () => clearTimeout(initialDelay);
  }, [showNotification]);
  useEffect(() => {
    if (!isVisible && !isExiting) {
      const randomDelay = 8000 + Math.random() * 4000;
      const timeout = setTimeout(() => {
        showNotification();
      }, randomDelay);
      return () => clearTimeout(timeout);
    }
  }, [isVisible, isExiting, showNotification]);
  if (!isVisible) return null;
  const notification = NOTIFICATIONS[currentIndex];
  return <div className={`fixed bottom-4 left-4 z-50 ${isExiting ? 'popup-exit' : 'popup-enter'}`} role="status" aria-live="polite" data-id="element-2">
      <div className="bg-white rounded-lg shadow-2xl border border-gray-200 p-4 max-w-xs flex items-center gap-3" data-id="element-3">
        <div className="w-10 h-10 rounded-full bg-solution text-white flex items-center justify-center font-bold text-sm flex-shrink-0" data-id="element-4">
          {notification.initials}
        </div>
        <div className="flex-1 min-w-0" data-id="element-5">
          <p className="text-sm font-semibold text-gray-900 truncate" data-id="element-6">
            {notification.name} de {notification.city}
          </p>
          <p className="text-xs text-gray-600" data-id="element-7">acaba de adquirir el PACK</p>
          <p className="text-xs text-green-600 font-medium mt-0.5" data-id="element-8">
            ✅ Compra verificada
          </p>
        </div>
      </div>
    </div>;
}